import { render, staticRenderFns } from "./RecipesModalTable.vue?vue&type=template&id=1adfd099&lang=pug"
import script from "./RecipesModalTable.vue?vue&type=script&lang=js"
export * from "./RecipesModalTable.vue?vue&type=script&lang=js"
import style0 from "./RecipesModalTable.vue?vue&type=style&index=0&id=1adfd099&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports